import { useMemo, useState } from 'react';
import { ActivityScreen } from './components/ActivityScreen';
import { CameraSetup } from './components/CameraSetup';
import { HelpScreen } from './components/HelpScreen';
import { HomeScreen } from './components/HomeScreen';
import { PrivacyScreen } from './components/PrivacyScreen';
import { PoseEngine } from './pose/PoseEngine';
import { TeacherPanel, type TeacherSettings } from './teacher/TeacherPanel';

type Screen='home'|'privacy'|'setup'|'activity'|'teacher'|'help';
const INITIAL:TeacherSettings={mode:'trail',level:1,cameraView:'camera',reducedMotion:false,activity:null,debug:false,prompt:null,presentation:false};

export default function App(){
  const [screen,setScreen]=useState<Screen>('home'),[fallback,setFallback]=useState(false),[settings,setSettings]=useState<TeacherSettings>(INITIAL);const engine=useMemo(()=>new PoseEngine(),[]);
  const home=()=>{engine.dispose();setFallback(false);setScreen('home')};
  if(screen==='privacy')return <PrivacyScreen onAccept={()=>setScreen('setup')} onBack={()=>setScreen('home')}/>;
  if(screen==='setup')return <CameraSetup engine={engine} onReady={()=>setScreen('activity')} onFallback={()=>{setFallback(true);setScreen('activity')}} onBack={home}/>;
  if(screen==='activity')return <ActivityScreen engine={engine} fallback={fallback} settings={settings} onSettings={setSettings} onFinish={home}/>;
  if(screen==='teacher')return <main className="screen teacher-standalone"><TeacherPanel inline settings={settings} onChange={setSettings} onClose={()=>setScreen('home')}/><button className="big-button primary return-activity" onClick={()=>setScreen('home')}>返回律動</button></main>;
  if(screen==='help')return <HelpScreen onBack={()=>setScreen('home')}/>;
  return <HomeScreen onStart={()=>setScreen('privacy')} onTeacher={()=>setScreen('teacher')} onHelp={()=>setScreen('help')}/>;
}
